// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-base-amount-dialog .table[data-v-1b868301] {
  height: 300px;
}
`, "",{"version":3,"sources":["webpack://./src/views/BillPricingSoftware/ConstructionCostBudget/SelectBaseAmountDialog.vue","webpack://./SelectBaseAmountDialog.vue"],"names":[],"mappings":"AACA;EAEI,aAAA;ACDJ","sourcesContent":["\n.select-base-amount-dialog {\n  .table {\n    height: 300px;\n  }\n}\n",".select-base-amount-dialog .table {\n  height: 300px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
